import { useState } from 'react';
import { Flex } from '@applyboard/crystal-ui';
import Desktop from './LoansFollowupFormDesktop';
import Mobile from './LoansFollowupFormMobile';
import { FileStatus } from './types';

const LoansFollowupForm = (props: { loanId?: string; onSubmit?: () => void }) => {
  const [fileStatus, setFileStatus] = useState<FileStatus[]>([]);
  // TODO: Most state handling from LoansFollowupFormDesktop and LoansFollowupFormMobile should be moved here

  return (
    <>
      <Flex hideBelow="md">
        <Desktop
          setFileStatus={setFileStatus}
          fileStatus={fileStatus}
          onSubmit={props.onSubmit}
          loanId={props.loanId}
        />
      </Flex>
      <Flex hideAbove="md">
        <Mobile
          setFileStatus={setFileStatus}
          fileStatus={fileStatus}
          onSubmit={props.onSubmit}
          loanId={props.loanId}
        />
      </Flex>
    </>
  );
};

export default LoansFollowupForm;
